import React from 'react';
import {
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Box,
} from '@material-ui/core';
// eslint-disable-next-line
import { useOpen } from 'useful-state';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import usePageLimit from '../usePageLimit';
import { usePageChange } from './ProductsPagination';

const ProductsLimit = () => {
  const openState = useOpen();

  const { limit, set } = usePageLimit();
  const change = usePageChange();

  return (
    <Box>
      <Tooltip title="# of results">
        <IconButton
          color="primary"
          onClick={openState.open}
        >
          <FormatListNumberedIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={openState.anchorEl}
        open={openState.isOpen}
        onClose={openState.close}
      >
        {[8, 16, 32, 64].map((x) => (
          <MenuItem
            dense
            selected={Number(limit) === x}
            style={{
              fontSize: '1rem',
              margin: 0,
            }}
            key={`perPage${x}`}
            onClick={() => {
              try {
                set(x);
                change();
                openState.close();
              } catch (e) {
                // eslint-disable-next-line
                alert(
                  'Failed to change results count. Please try again.',
                );
              }
            }}
          >
            {x} per page
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

ProductsLimit.propTypes = {};

export default ProductsLimit;
